module.exports = __webpack_public_path__ + "static/images/2610cd8e787cd80c2ea98a61c81f6b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fail_default.png
// module id = 497
// module chunks = 1 2 14